// ワードプレスのクライアントユーティリティです。
// axios の設定が見たい場合は、こちらへ
import wpClient from '../utils/wpClient.js'
// wpServiceとして使われる
// getNews と 何が違うのか ？ 抽象度？
const wordpress = {
  // カテゴリー ９ を 10 件取得する
  getPostsInCategories: (id, limit) => {
    // categories や per_page は REST APIの用語です。
    const data = {
      categories: id,
      per_page: limit
    }
    // wp/v2/posts/?categories=9&per_page=10
    return wpClient().get('wp/v2/posts', { params: data })
  },
  getNewsInCategories: (id, limit) => {
    // categories や per_page は REST APIの用語です。
    const data = {
      per_page: limit
    }
    // wp/v2/news/?categories=9&per_page=10
    return wpClient().get("wp/v2/news", { params: data })
  },
  // コレは単純に投稿を取得するものです。
  getPostById: (id) => {
    // /wp/v2/posts/12345
    return wpClient().get(`wp/v2/posts/${id}`)
  },
  getNewsById: (id) => {
    // /wp-json/v2/news/12345
    return wpClient().get(`wp/v2/news/${id}`)
  },
  getStreamerById: (id) => {
    const data = {
      per_page: 100,
      page: 1
    }
    // /wp-json/v2/stremaer/12345
    return wpClient().get(`wp/v2/streamer/${id}?_embed`, { params: data })
    // return wpClient().get(`wp/v2/streamer/${id}?_embed&per_page=100&page=1`)
  },

  // Topslide
  getTopslideById: (id) => {
    const data = {
      per_page: 100,
      page: 1
    }

    return wpClient().get(`wp/v2/topslide/${id}?_embed`, { params: data })

  },

  // MvPc
  getMvPcById: (id) => {
    const data = {
      per_page: 100,
      page: 1
    }

    return wpClient().get(`wp/v2/mvpc/${id}?_embed`, { params: data })

  },

  //MvSp
  getMvSpById: (id) => {
    const data = {
      per_page: 100,
      page: 1
    }

    return wpClient().get(`wp/v2/mvsp/${id}?_embed`, { params: data })

  },

  //TopBanner
  getTopBannerById: (id) => {
    const data = {
      per_page: 100,
      page: 1
    }

    return wpClient().get(`wp/v2/topbanner/${id}?_embed`, { params: data })

  },

  // これは、FAQ をすべて取得します
  getQuestionAnswerAll: () => {
    const data = {
      _fields: 'id,title,content.rendered,categories,category_name,status,description',
      per_page: 100,
      page: 1
    }
    //console.log(wpClient().get('wp/v2/faq', { params: data }))
    // /wp/v2/faq/type
    //console.log(wpClient().get('wp/v2/faq', { params: data }))
    return wpClient().get("wp/v2/faq", { params: data })
  },
  getCategories: () => {
    const data = {
      _fields: 'name,id,count,slug,taxonomy'
    }

    console.log("wordpress > getCategories():",wpClient().get('wp/v2/categories', { params: data }))
    return wpClient().get("wp/v2/categories", { params: data })
  },





  getStreamerInCategories: (limit) => {
    // wp/v2/streamer?_embed
    const data = {
      per_page: limit
    }
    //console.log(wpClient().get('wp/v2/streamer?_embed', { params: data }))
    return wpClient().get('wp/v2/streamer?_embed', { params: data })
  },
  getStreamerInCategoriesAll: () => {
    // wp/v2/streamer?_embed
    const data = {
      per_page: 100,
      page: 1
    }

    return wpClient().get('wp/v2/streamer?_embed', { params: data })
  },





  getTopslideInCategories: (limit) => {

    const data = {
      per_page: limit
    }
    //console.log(wpClient().get('wp/v2/streamer?_embed', { params: data }))
    return wpClient().get('wp/v2/topslide?_embed', { params: data })
  },
  getTopslideInCategoriesAll: () => {

    const data = {
      per_page: 100,
      page: 1
    }

    return wpClient().get('wp/v2/topslide?_embed', { params: data })
  },

  // mvpc
  getMvPcInCategories: (limit) => {

    const data = {
      per_page: limit
    }

    return wpClient().get('wp/v2/mvpc?_embed', { params: data })
  },
  getMvPcInCategoriesAll: () => {

    const data = {
      per_page: 100,
      page: 1
    }

    return wpClient().get('wp/v2/mvpc?_embed', { params: data })
  },


  // mvsp
  getMvSpInCategories: (limit) => {

    const data = {
      per_page: limit
    }

    return wpClient().get('wp/v2/mvsp?_embed', { params: data })
  },
  getMvSpInCategoriesAll: () => {

    const data = {
      per_page: 100,
      page: 1
    }

    return wpClient().get('wp/v2/mvsp?_embed', { params: data })
  },


  // topbanner
  getTopBannerInCategories: (limit) => {

    const data = {
      per_page: limit
    }

    return wpClient().get('wp/v2/topbanner?_embed', { params: data })
  },
  getTopBannerInCategoriesAll: () => {

    const data = {
      per_page: 100,
      page: 1
    }

    return wpClient().get('wp/v2/topbanner?_embed', { params: data })
  },

}

//console.log(wordpress)

export default wordpress
